<template>
  <div id="rules">
    <div id="occupied"></div>
    <!-- 快速参赛 -->
    <!-- <div class="quick-entry-container" id="sss">
      <div class="big-title">
        快速参赛
      </div>
      <p class="explain">
        报名参赛前请下载迷你世界，通过游客登录、设置密码获取迷你号
      </p>
      <div class="content">
        <div class="wrap">
          <div class="img-title">
            <img src="../assets/images/img_num1.png" />
            <span>获取迷你号</span>
          </div>
          <span style="color:#ff874b"
            >（安卓移动端官版与PC端账号互通，建议下载官版）</span
          >
          <div class="link-box">
            <div class="btn-link">
              <a :href="getType == 'iphone' ? iphoneGameLink : androidGameLink"
                ><p>下载官版</p></a
              >
            </div>
          </div>
        </div>
        <div class="wrap">
          <div class="img-title">
            <img src="../assets/images/img_num2.png" />
            <span>报名参赛</span>
          </div>
          <div class="link-box">
            <div class="btn-link">
              <p @click="$router.push('/works')">报名参赛</p>
            </div>
          </div>
        </div>
        <div class="wrap">
          <div class="img-title">
            <img src="../assets/images/img_num2.png" />
            <span>免费自学教程攻略</span>
          </div>
          <div class="link-box">
            <div
              class="btn-link"
              v-for="(btn, b) in btnArr"
              :key="b"
              @click="handleDownload(b)"
            >
              <a :href="btn.link">
                <p>
                  {{ btn.name }}
                </p>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 认证开发者 -->
    <!-- <div class="certified-developer-container">
      <div class="big-title">
        认证开发者
      </div>
      <p class="explain">
        完成投稿后将可以获得开发者资格，前往开发者中心完成认证后即正式成为开发者。
      </p>
      <div class="content">
        <div class="wrap">
          <div class="img-title">
            <img src="../assets/images/img_num1.png" />
            <span>前往开发者中心</span>
          </div>
          <p>（并登录个人迷你号）</p>
          <div class="link-box">
            <a class="btn-link go-login" href="https://kfz.mini1.cn/#/login">
              <p class="green" @click="handleDownload(4)">前往登录</p>
            </a>
          </div>
          <div
            class="big-img-box"
            v-for="(img, im) in geamGuideDtat.bigImgArr"
            :key="im"
          >
            <div class="img-title">
              <img :src="img.icon" />
              <span>{{ img.smallTitle }}</span>
            </div>
            <p>{{ img.explainTxt }}</p>
            <div class="bigger-box">
              <img
                class="bigger-img"
                :src="img.img"
                @click="bigImgFn(img.img)"
              />
            </div>
          </div>
        </div>
      </div>
    </div> -->
    <!-- 赛程说明 -->
    <div class="process-container">
      <div class="big-title">
        赛程说明
      </div>
      <div class="captions">
        <div
          class="paragraph"
          v-for="(txt, t) in geamGuideDtat.captionsArr"
          :key="t"
        >
          <div class="txt-detail">
            <span class="txt-label">{{ txt.label }}</span>
            <p class="time">{{ txt.time }}</p>
          </div>
          <p class="more-txt" v-for="(deta, de) in txt.detail" :key="de">
            {{ deta }}
          </p>
        </div>
      </div>
    </div>
    <!-- 投稿说明 -->
    <div class="work-require-container">
      <div class="big-title">
        投稿说明
      </div>
      <div class="content">
        <div
          class="detail"
          v-for="(work, w) in geamGuideDtat.workRequireArr"
          :key="w"
        >
          <p class="txt" v-for="(de, d) in work" :key="d">{{ de }}</p>
        </div>
      </div>
    </div>
    <!-- 评审标准 -->
    <div class="review-standards-container">
      <div class="big-title">
        评审标准
      </div>
      <div class="content">
        <div
          class="standard-wrap"
          v-for="(rev, r) in geamGuideDtat.standardArr"
          :key="r"
        >
          <p class="title">{{ rev.title }}</p>
          <div class="standard-box">
            <p>{{ rev.standard }}</p>
            <div
              class="standard-detail"
              v-for="(angle, a) in rev.AngleArr"
              :key="a"
            >
              <span class="label">{{ angle.label }}</span>
              <span>{{ angle.txt }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 奖金发放 -->
      <div class="award-issue-container">
        <div class="big-title">
          奖金发放
        </div>
        <div class="content">
          <div
            class="detail"
            v-for="(award, aw) in geamGuideDtat.awardArr"
            :key="aw"
          >
            <span class="txt">{{ award }}</span>
          </div>
          <p>注：有关参赛相关疑问可咨询大赛交流群的官方工作人员。</p>
        </div>
      </div>

      <!-- <div class="btn-suspend" @click="$router.push('/works')">
        <img src="../assets/images/btn_go_apply.png" />
      </div> -->
    </div>
  </div>
</template>

<script>
import { ImagePreview } from 'vant';
import { geamGuideDtat } from '../common/pageData';
export default {
  name: 'homePage',
  data() {
    return {
      geamGuideDtat: geamGuideDtat,
      btnArr: [
        {
          name: '游戏创作教程',
          link: 'https://www.mini1.cn/article/20200916/1446.html'
        },
        { name: '触发器教程', link: 'https://developers.mini1.cn/cfqwiki/' }
      ],
      androidBoxLink: 'https://helper.miniworldbox.com/index/apk/android',
      iphoneBoxLink:
        'https://itunes.apple.com/cn/app/%E8%BF%B7%E4%BD%A0%E7%9B%92%E5%AD%90/id1363389095?mt=8',
      iphoneGameLink:
        'https://itunes.apple.com/cn/app/%E8%BF%B7%E4%BD%A0%E4%B8%96%E7%95%8C-%E5%85%A8%E6%B0%91%E5%88%9B%E4%BD%9C%E7%9A%84%E6%B2%99%E7%9B%92%E5%B9%B3%E5%8F%B0/id1170455562?mt=8',
      androidGameLink: 'https://app.mini1.cn/export/down_app/1'
    };
  },
  computed: {
    // 判断pc|android|iphone
    getType() {
      let phoneType = '';
      let iphone = /(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent);
      if (iphone) {
        phoneType = 'iphone';
      } else {
        phoneType = 'android';
      }
      return phoneType;
    },
    isLogin() {
      if (window.sessionStorage.getItem('currentUser') != 'null') {
        this.$store.commit(
          'userStatus',
          JSON.parse(window.sessionStorage.getItem('currentUser'))
        );
      } else {
        this.$store.commit('userStatus', null);
      }
      return this.$store.getters.isLogin;
    }
  },
  mounted() {
    this.$scroll('occupied');
    window.sessionStorage.setItem(
      'pathName',
      window.location.hash.split('#')[1]
    );
  },
  methods: {
    bigImgFn(val) {
      ImagePreview({
        images: [val],
        showIndex: false
      });
    },
    handleDownload(index) {
      let v8 = '';
      switch (index) {
        case 0:
          v8 = 2;
          break;
        case 1:
          v8 = 3;
          break;
        case 4:
          v8 = 4;
          break;
        default:
          break;
      }
      this.$reportLog(16066, { v8: v8 });
    }
  }
};
</script>

<style lang="scss" scoped>
#rules {
  margin-bottom: 50px;
  width: 750px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: rgb(53, 53, 53);
  font-size: 26px;
  .big-title {
    margin-top: 50px;
    font-size: 60px;
    font-weight: 800;
    color: rgb(53, 53, 53);
  }
  .explain {
    margin: 30px 40px;
    text-align: center;
  }
  .quick-entry-container,
  .certified-developer-container,
  .process-container,
  .work-require-container,
  .review-standards-container,
  .award-issue-container {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  // 快速参赛 认证开发者
  .quick-entry-container,
  .certified-developer-container {
    .content {
      .wrap {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .img-title {
          display: flex;
          align-items: center;
          img {
            width: 55px;
            height: 25px;
            margin-right: 10px;
          }
          span {
            font-size: 30px;
            font-weight: 600;
          }
        }
        .link-box {
          display: flex;
          align-items: center;
          justify-content: space-around;
          flex-wrap: wrap;
          width: 700px;
          padding: 40px 10px;
          background: #efefef;
          margin: 20px 0 40px;
          .btn-link {
            p {
              padding: 20px 30px;
              background: #f1a269;
              border-radius: 15px;
              color: #fff;
              font-size: 28px;
              font-weight: 600;
            }
            .black {
              background: #000;
            }
            .green {
              background: #45a16e;
            }
          }
          .go-login {
            width: 250px;
            // height: 30px;
            display: flex;
            align-items: center;
            justify-content: center;
            p {
              width: 100%;
              text-align: center;
            }
          }
        }
      }
    }
  }
  // 认证开发者
  .certified-developer-container {
    .big-img-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 20px 0 40px;
      .bigger-box {
        // width: 700px;
        // height: 580px;
        border: 1px solid#45a16e;
        width: 250px;
        height: 82px;
        overflow: hidden;
        display: flex;
        align-items: center;
        justify-content: center;
        .bigger-img {
          margin: 20px 0;
          overflow: hidden;
        }
      }
    }
  }
  // 赛程说明
  .process-container {
    .captions {
      padding: 30px;
      display: flex;
      flex-direction: column;
      justify-content: start;
      .paragraph {
        margin: 20px 0;
        display: flex;
        flex-direction: column;
        .txt-label {
          // width: 120px;
          color: #f1a269;
        }
        .txt-label,
        .time {
          font-size: 30px;
          font-weight: 600;
        }
        .more-txt {
          margin-top: 5px;
          text-align: justify;
        }
        .txt-detail {
          display: flex;
        }
      }
    }
  }
  // 投稿说明 奖金发放
  .work-require-container,
  .award-issue-container {
    .content {
      padding: 30px;

      .detail {
        display: flex;
        flex-direction: column;
        margin: 20px 0;
      }
    }
  }
  .work-require-container {
    .txt {
      margin-top: 5px;
      text-align: justify;
    }
  }
  // 评审标准
  .review-standards-container {
    .content {
      padding: 20px 30px;
      .standard-wrap {
        margin-bottom: 40px;
        .title {
          font-size: 30px;
          font-weight: 600;
          color: #f1a269;
          margin: 20px 0;
        }
        .standard-detail {
          margin-top: 10px;
          .label {
            font-weight: 600;
          }
        }
      }
      .annotation {
        color: #f1a269;
        margin: 30px 0;
        display: flex;
      }
    }
  }
  // 奖金发放
  .award-issue-container {
    p {
      color: #f1a269;
      margin-top: 20px;
    }
  }
}
</style>
